var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.description.constructor !== Array
    ? _c("div", { staticClass: "wine-description-container" }, [
        _c("div", { staticClass: "description-container" }, [
          _c("div", {
            staticClass: "wine-description-text",
            domProps: { innerHTML: _vm._s(_vm.description) },
          }),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }